
import Vue from "vue";

export default Vue.extend({
  name: "DocumentPhoto",
  props: {
    label: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: false,
      default: null,
    },
    alt: {
      type: String,
      required: false,
      default: null,
    },
  },
});
